import {deepmerge} from "@mui/utils";
import {type Palette} from "@mui/material/styles";
import {type TypographyOptions as MuiTypographyOptions} from "@mui/material/styles/createTypography";
import {fontWeight, variants} from "./tokens";
import type {FontWeight, Variants} from "./types";

declare module "@mui/material/styles/createTypography" {
    // eslint-disable-next-line @typescript-eslint/no-empty-interface
    interface Typography extends Variants {
        fontWeight: FontWeight;
    }

    interface TypographyOptions extends Partial<Variants> {
        fontWeight?: Partial<FontWeight>;
    }
}

export function createTypography(
    options: MuiTypographyOptions | ((palette: Palette) => MuiTypographyOptions) = {},
) {
    return deepmerge(
        {
            ...variants,
            fontWeight,
        },
        {...options},
    );
}
